import { dataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';
import React from 'react';
import ChiliPiperComponent from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperComponent';
import { FDDialog } from '@facet-wealth/design';

const ChiliPiperComponentInFullScreenDialog = ({ chiliPiperRel, handleChiliPiperExit }) => {
  return (
    <FDDialog
      open
      closeOnBackdropClick
      fullScreen
      noCloseButton
      {...dataAttrs('chilipiper-dialog')}
    >
      <ChiliPiperComponent rel={chiliPiperRel} handleChiliPiperExit={handleChiliPiperExit} />
    </FDDialog>
  );
};

ChiliPiperComponentInFullScreenDialog.defaultProps = {
};

ChiliPiperComponentInFullScreenDialog.propTypes = {
  chiliPiperRel: PropTypes.object.isRequired,
  handleChiliPiperExit: PropTypes.func.isRequired,
};

export default ChiliPiperComponentInFullScreenDialog;
